import * as React from 'react';
import { FC, useState, useEffect, useRef } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Consumer, Subscription } from '@rails/actioncable';
import { moneyStr } from 'app/helpers/money';
import locales from 'app/CasinoGames/locales';
import JackpotViews, { JackpotViewsProps } from './Jackpots';

export const WIN_SHOW_TIME = 5000;

type Win = {
  player: string;
  jackpot: string;
  currency: string;
  prize: number;
};

const useWins = (): Win | undefined => {
  const [win, setWin] = useState<Win>();
  const timer = useRef<NodeJS.Timeout | undefined>(undefined);

  useEffect(() => {
    const cable = window.cable as Consumer;
    const subscription: Subscription = cable.subscriptions.create(
      {
        channel: 'JackpotAggregator::WinsChannel',
      },
      {
        received: (v) => {
          setWin(v);
          clearTimeout(timer.current);
          timer.current = setTimeout(setWin, WIN_SHOW_TIME, undefined);
        },
      }
    );

    return () => {
      clearTimeout(timer.current);
      subscription.unsubscribe();
    };
  }, []);

  return win;
};

const WinComponent: FC<{ win: Win }> = ({ win }) => {
  const l = locales();

  return (
    <div className="other-winner o-winner">
      <div className="o-winner_info">{`${win.player} ${l.jackpot_aggregator_wins_won}`}</div>
      <div className="o-winner_jackpot">
        <div className="o-winner_image" />
        <div className="o-winner_name">{win.jackpot}</div>
        <div className="o-winner_amount">{moneyStr(win.prize, win.currency)}</div>
      </div>
    </div>
  );
};

type JackpotsAndWinsProps = JackpotViewsProps;

const JackpotsAndWins: FC<JackpotsAndWinsProps> = ({ campaignViews }) => {
  const win = useWins();

  return (
    <div className="jackpot-badge">
      {win && <WinComponent win={win} />}
      <div style={{ display: win ? 'none' : 'block' }}>
        <JackpotViews campaignViews={campaignViews} />
      </div>
    </div>
  );
};

const WrappedJackpots: FC<JackpotsAndWinsProps> = (props) => (
  <ErrorBoundary fallback={<div className="error">Error</div>}>
    <JackpotsAndWins {...props} />
  </ErrorBoundary>
);

export default WrappedJackpots;
